// Phase 15.3 — Narrow RL policy API client.
import { api as client } from "@/api/client";

const BASE = "/api/rl-policies";

export const rlPolicies = {
    train: (body) => client.post(`${BASE}/train`, body).then((r) => r.data),
    list: (sourceCampaignId) =>
        client.get(BASE, { params: { source_campaign_id: sourceCampaignId } })
            .then((r) => r.data),
    get: (id) => client.get(`${BASE}/${id}`).then((r) => r.data),
};

export default rlPolicies;
